<template>
  <b-container fluid class="">
    <h1 class="m-3">
      {{ title }}
    </h1>
    <commonActions :data-ready="dataReadyTables" :filename-prefix="title"
      @commonFiltersUpdated="commonFiltersUpdated($event)" @clickDownloadPdf="downloadPdf($event)"
      @clickDownloadExcel="downloadExcel($event)" @clickDownloadCsv="downloadCsv($event)" />
    <table-renderer v-for="data of tablesData" :key="data.tableNumber" :data-table="data.dataTable"
      :dimension-fields="dimensionColumnsTables" :measure-fields="measureColumnsTables" :table-header="data.tableHeader"
      :group-headers="groupHeaders" :default-sorted-column="defaultSortedColumnTables" :totals-data="data.totalsData"
      :data-ready="dataReadyTables" custom-table-class="table-width-medium" ref="tableRenderers" />
  </b-container>
</template>

<script>
import { mapState } from "vuex";
import { StaffViewsEnum } from "@/utils/staffEnum";
import Tools from "@/utils/tools";
import TableTools from "@/utils/tableTools";
import paths from "@/router/pathConstants";
import TableRenderer from "@/components/TableRenderer.vue";
import commonActions from "@/components/pages/commonActions";
import dimensionEnum from "@/model/dimensionEnum";
import mesureEnum from "@/model/mesureEnum";
import i18n from "@/plugins/vue-i18n.js";

import { Staff } from "@/router/routeNames";

export default {
  name: Staff,
  components: {
    TableRenderer,
    commonActions,
  },
  data() {
    return {
      /** Tableau de filtres tels qu'attendu par cubeJs.
       * Ex :
       *    [
       *      {
       *        dimension: "Site.Id",
       *        operator: "equals",
       *        values: ["85007419-23D3-48AB-89E7-68089F46FA7D"]
       *      },
       *      {
       *        dimension: "BusinessDate.id",
       *        operator: "inDateRange",
       *        values: ["2020-09-23", "2020-09-26"]
       *      },
       */
      commonFilters: [],
      dimensions:
        [
          dimensionEnum.EMPLOYEE_LASTNAME,
          dimensionEnum.EMPLOYEE_FIRSTNAME,
          dimensionEnum.EMPLOYEE_ROLE,
          dimensionEnum.STAFFGAMEHISTORY_CARDNUMBER,
        ],
      measures:
        [
          mesureEnum.STAFFGAMEHISTORY_COUNT,
          mesureEnum.STAFFGAMEHISTORY_TOKENCREDITED,
          mesureEnum.STAFFGAMEHISTORY_REVENUE_EQUIVALENT_TTC,
          mesureEnum.ADJUSTMENTHISTORY_COUNT,
          mesureEnum.ADJUSTMENTHISTORY_AMOUNT,
        ],
      groupHeaders:
        [
          { nbOfMeasures: 3, label: i18n.t("group.refunds") },
          { nbOfMeasures: 2, label: i18n.t("group.cardCreation") }
        ]
    };
  },
  computed: {
    ...mapState({
      dimensionColumnsTables: (state) => state.staff.dimensionColumnsTables,
      measureColumnsTables: (state) => state.staff.measureColumnsTables,
      defaultSortedColumnTables: (state) =>
        state.staff.defaultSortedColumnTables,
      tablesData: (state) => state.staff.tablesData,
      dataReadyTables: (state) => state.staff.dataReadyTables,
    }),
    title() {
      return this.$t("title.staff");
    },
  },
  mounted() {
    this.$store.dispatch("staff/initDisplayTables", {
      dimensions: this.dimensions,
      measures: this.measures,
      siteCurrency: 'EUR'
    });
  },
  methods: {
    async commonFiltersUpdated(value) {
      try {
        this.$store.dispatch("staff/resetDataReadyTables");
        this.commonFilters = value.filters;
        await this.$store.dispatch("staff/updateTableList", {
          filters: this.commonFilters,
          timeDimension: value.timeDimension || null,
          siteValues: value.siteValues,
          staffView: StaffViewsEnum.staffReport,
          dimensions: this.dimensions,
          measures: this.measures
        });
      } catch (error) {
        Tools.Alerts.Error(this.$swal, error);
      }
    },
    downloadPdf(data) {
      if (this.dataReadyTables) {
        this.storeExportData(data.filename, data.subtitles);
        window.open(paths.EXPORT_PDF, "_blank");
      }
    },
    downloadExcel(data) {
      if (this.dataReadyTables) {
        this.storeExportData(data.filename, data.subtitles);
        window.open(paths.EXPORT_EXCEL, "_blank");
      }
    },
    downloadCsv(data) {
      if (this.dataReadyTables) {
        this.storeExportData(data.filename, data.subtitles);
        window.open(paths.EXPORT_CSV, "_blank");
      }
    },
    storeExportData(filename, subtitles) {
      const self = this;
      var datasForExport = [];

      self.tablesData.forEach((table, index) => {
        const renderer = self.$refs.tableRenderers?.[index];
        const sortKey = renderer?.sortedColumn || self.defaultSortedColumnTables;

        const data = TableTools.Helper.assembleExportDataTable(
          table.dataTable,
          self.dimensionColumnsTables,
          self.measureColumnsTables,
          self.groupHeaders,
          table.tableHeader,
          sortKey,
          null,
          table.totalsData
        );
        datasForExport.push(data);
      });

      TableTools.Helper.storeExportData(
        datasForExport,
        self.title,
        subtitles,
        filename
      );
    },
  },
};
</script>
